// Dateline clock — ticks HH:MM in the site dateline strip.

const DAY_SHORT = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const MONTH_SHORT = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function format(now) {
    const day = DAY_SHORT[now.getDay()];
    const date = String(now.getDate()).padStart(2, "0");
    const month = MONTH_SHORT[now.getMonth()];
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `${day}, ${date} ${month}, ${hours}:${minutes}`;
}

export default function dateline() {
    const el = document.querySelector("[data-dateline-clock]");
    if (!el) return;

    const tick = () => {
        el.textContent = format(new Date());
    };

    tick();
    setInterval(tick, 30 * 1000);
}
